import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const Segment = React.lazy(() => import('./Segment'));

export default class SegmentWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense>
          <Segment
            config={this.props.config}
            reportEvent={this.props.reportEvent(this.props.config.id)}
          />
        </Suspense>
      </div>
    );
  }
}

SegmentWrapper.propTypes = {
  config: PropTypes.object.isRequired,
  reportEvent: PropTypes.func,
};
